import React, { FC } from 'react';
import { AllieChip, AllieText } from '../../../components';
import { AllieDotIcon } from '../../../styling/icons';

export enum ProductionOrderStatus {
  IN_PROGRESS = 'in_progress',
  PAUSED = 'paused',
  STOPPED = 'stopped',
  TECHNICAL_STOP = 'technical_stop',
  NO_PRODUCTION = 'no_production',
  SUSPENDED = 'suspended',
}

interface AllieProductionOrderStatusChipProps {
  status: string;
  statusLabel: string;
  style?: React.CSSProperties;
}

export const AllieProductionOrderStatusChip: FC<AllieProductionOrderStatusChipProps> = ({
  status,
  statusLabel,
  style: overrideStyle,
}) => {
  const mapProductionStatusChipBorder: Record<string, string> = {
    in_progress: '1.5px solid var(--allie-color-success-70)',
    stopped: '1.5px solid var(--allie-color-error-70)',
    paused: '1.5px solid var(--allie-color-neutral-60)',
    no_productions: '1.5px solid var(--allie-color-neutral-60)',
    technical_stop: '1.5px solid var(--allie-color-neutral-60)',
    planned_stop: '1.5px solid var(--allie-color-neutral-60)',
    unplanned_stop: '1.5px solid var(--allie-color-error-70)',
  };
  const mapProductionStatusChipColor: Record<string, string> = {
    in_progress: 'var(--allie-color-success-70)',
    stopped: 'var(--allie-color-error-70)',
    paused: 'var(--allie-color-neutral-70)',
    no_productions: 'var(--allie-color-neutral-70)',
    technical_stop: 'var(--allie-color-neutral-70)',
    planned_stop: 'var(--allie-color-neutral-70)',
    unplanned_stop: 'var(--allie-color-error-70)',
  };

  return (
    <>
      {status && (
        <AllieChip
          style={{
            height: 22,
            cursor: 'default',
            border: mapProductionStatusChipBorder[status!],
            borderRadius: '50px',
            padding: '2px 6px',
            gap: '4px',
            fontSize: '12px',
            backgroundColor:
              status === ProductionOrderStatus.NO_PRODUCTION ? 'var(--allie-color-neutral-5)' : '',
            ...overrideStyle,
          }}
        >
          <AllieText
            type="body2"
            style={{
              color: mapProductionStatusChipColor[status!],
              textWrap: 'nowrap',
              fontSize: '12px',
              fontWeight: 500,
            }}
          >
            {statusLabel}
          </AllieText>
        </AllieChip>
      )}
    </>
  );
};
